import { Fragment } from 'react/jsx-runtime'
import { AuthGuardProps } from './props'
import authStore from '../../../store/authStore'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import links from '../../../routes/links'

export default function AuthGuard(props: AuthGuardProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const user = authStore(state => state.user)

  useEffect(() => {
    if (!!user) {
      const rollback = searchParams.get('rb')
      if (!!rollback) navigate(rollback)
      else navigate(links.public.home())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  if (!user) return <Fragment>{props.children}</Fragment>
  return null
}
